var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("notifications", {
        attrs: {
          group: _vm.groupNotify,
          closeOnClick: false,
          width: 500,
          max: 5,
          "animation-name": "v-fade-left",
          position: "top left",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function (props) {
              return [
                _c("div", { staticClass: "custom-template" }, [
                  _c("div", { staticClass: "custom-template-icon" }, [
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: { target: "_blank", href: props.item.data.url },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src:
                              props.item.data.images &&
                              props.item.data.images.small.length
                                ? props.item.data.images.small[0]
                                : "/upload/empty/58.png",
                            width: "58",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "custom-template-content" }, [
                    _c("div", { staticClass: "custom-template-title" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(props.item.title) +
                          "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "custom-template-text",
                      domProps: { innerHTML: _vm._s(props.item.text) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "custom-template-close",
                      on: {
                        click: function ($event) {
                          return _vm.close(props.item.data.id)
                        },
                      },
                    },
                    [_c("i", { staticClass: "icon icon-close" })]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalSertificateVisible
        ? _c("modal-sertificate", {
            attrs: { item: _vm.item },
            on: { close: _vm.closeModalSertificate },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.item && Object.keys(_vm.item).length > 0,
              expression: "item && Object.keys(item).length > 0",
            },
          ],
          staticClass: "catalog",
        },
        [
          _c("h1", [_vm._v("\n      " + _vm._s(_vm.item.name) + "\n    ")]),
          _vm._v(" "),
          _c("breadcrumbs", {
            attrs: { items: _vm.item.breadcrumbs, name: _vm.item.name },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "catalog catalog_view_detail" }, [
            _c(
              "div",
              {
                staticClass: "catalog__product-info product product_view_card",
              },
              [
                _c("div", { staticClass: "product__content-inner" }, [
                  _c(
                    "div",
                    { staticClass: "product__header-info" },
                    [
                      _c("div", { staticClass: "product__options-info" }, [
                        _c(
                          "span",
                          { staticClass: "product__options-info-item" },
                          [
                            _vm._v("Код:\n                      "),
                            _c(
                              "vue-popper",
                              {
                                attrs: {
                                  id: _vm.item.id + "-xmlid",
                                  hint: "Копировать",
                                  "hint-click": "Скопировано",
                                },
                                on: { hinted: _vm.copy },
                              },
                              [_vm._v(_vm._s(_vm.item.code))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "product__options-info-item" },
                          [
                            _vm._v("Артикул:\n                      "),
                            _c(
                              "vue-popper",
                              {
                                attrs: {
                                  id: _vm.item.id + "-vendorCode",
                                  hint: "Копировать",
                                  "hint-click": "Скопировано",
                                },
                                on: { hinted: _vm.copy },
                              },
                              [_vm._v(_vm._s(_vm.item.vendorCode))]
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "product__options-info-item" },
                          [
                            _vm._v("Штрих-код:\n                      "),
                            _c(
                              "vue-popper",
                              {
                                attrs: {
                                  id: _vm.item.id + "-barcode",
                                  hint: "Копировать",
                                  "hint-click": "Скопировано",
                                },
                                on: { hinted: _vm.copy },
                              },
                              [_vm._v(_vm._s(_vm.item.barcode))]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.user.isAuthorized
                        ? _c("product-statuses", { attrs: { item: _vm.item } })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "product__picture" }, [
                    _vm.item.badge && _vm.item.badge.length > 0
                      ? _c("div", { staticClass: "product__badges" }, [
                          _vm.item.badge.includes("hit")
                            ? _c("span", { staticClass: "product__badge" }, [
                                _vm._v("Хит"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.badge.includes("new")
                            ? _c("span", { staticClass: "product__badge" }, [
                                _vm._v("Новинка"),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.item.badge.includes("action")
                            ? _c("span", { staticClass: "product__badge" }, [
                                _vm._v("Акция"),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "product__picture-slider" },
                      [
                        _vm.item.images && _vm.item.images.large.length > 0
                          ? [
                              _c("vue-swiper", {
                                key: _vm.item.id,
                                attrs: {
                                  images: _vm.item.images.large,
                                  "item-id": _vm.item.id,
                                },
                              }),
                            ]
                          : [_vm._m(0)],
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "product__to_favorite",
                        on: {
                          click: function ($event) {
                            return _vm.toFavorite(_vm.item)
                          },
                        },
                      },
                      [
                        _c("span", {
                          staticClass: "icon",
                          class: {
                            "icon-heart": !_vm.item.favorite,
                            "icon-heart-full": _vm.item.favorite,
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.item.is_archive
                    ? _c("div", { staticClass: "product__actions" }, [
                        _vm.user.isAuthorized
                          ? _c("div", { staticClass: "product__prices" }, [
                              _vm.item.price.stock != _vm.item.price.price
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "product__price product__price_type_old",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            Math.round(
                                              _vm.item.price.stock *
                                                _vm.item.step *
                                                100
                                            ) / 100
                                          ) +
                                          " Р.\n                "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "percent-badge percent-badge_theme_yellow percent-badge_size_xs product__price-percent",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "percent-badge__value",
                                            },
                                            [
                                              _c(
                                                "vue-popper",
                                                {
                                                  attrs: {
                                                    id:
                                                      _vm.item.id +
                                                      "-el-percent",
                                                    hint: "Ваша персональная скидка на данную категорию товаров",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.item.price.percent
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "product__price" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      Math.round(
                                        _vm.item.price.price *
                                          _vm.item.step *
                                          100
                                      ) / 100
                                    ) +
                                    " Р.\n              "
                                ),
                              ]),
                              _vm._v(" "),
                              _vm.item.dimensions
                                ? _c(
                                    "div",
                                    { staticClass: "product__buy-action" },
                                    [
                                      _c("product-summary-controls", {
                                        attrs: {
                                          item: _vm.item,
                                          productId: _vm.item.id,
                                          v: _vm.item.dimensions.volume,
                                          x: _vm.item.code,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ])
                    : _c("div", { staticClass: "product__noreg-box" }, [
                        _c("div", { staticClass: "product__noreg-box-text" }, [
                          _vm._v(
                            "\n              Видеть цены и покупать могут только зарегистрированные пользователи\n            "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass:
                              "product__noreg-box-button button button_theme_primary_blue button_size_md",
                            attrs: {
                              href: "/auth/?login=yes&backurl=" + _vm.back_url,
                            },
                          },
                          [
                            _c("span", { staticClass: "button__text" }, [
                              _vm._v("Войти и купить"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "/auth/?register=yes&backurl=" + _vm.back_url,
                            },
                          },
                          [_vm._v("Зарегистрироваться")]
                        ),
                      ]),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product__main-info" }, [
            _c("div", { staticClass: "product__options-group" }, [
              _vm.item.dimensions
                ? _c(
                    "ul",
                    { staticClass: "product__options product__options_lists" },
                    [
                      _vm.item.dimensions.volume
                        ? _c("li", { staticClass: "product__options-item" }, [
                            _c(
                              "span",
                              { staticClass: "product__options-item-caption" },
                              [_vm._v("Объем")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "product__options-item-value" },
                              [
                                _vm._v(
                                  _vm._s(_vm.item.dimensions.volume) + " м³"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.dimensions.size
                        ? _c("li", { staticClass: "product__options-item" }, [
                            _c(
                              "span",
                              { staticClass: "product__options-item-caption" },
                              [_vm._v("Размер(ГхШхВ)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "product__options-item-value" },
                              [_vm._v(_vm._s(_vm.item.dimensions.size) + " см")]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.dimensions.weight != ""
                        ? _c("li", { staticClass: "product__options-item" }, [
                            _c(
                              "span",
                              { staticClass: "product__options-item-caption" },
                              [_vm._v("Вес (грамм)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "product__options-item-value" },
                              [_vm._v(_vm._s(_vm.item.dimensions.weight))]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.item.dimensions.pack_size
                        ? _c("li", { staticClass: "product__options-item" }, [
                            _c(
                              "span",
                              { staticClass: "product__options-item-caption" },
                              [_vm._v("Размер упак.(ГхШхВ)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "product__options-item-value" },
                              [
                                _vm._v(
                                  _vm._s(_vm.item.dimensions.pack_size) + " см"
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(
                        _vm.item.properties,
                        function (value, name, index) {
                          return _c(
                            "li",
                            { staticClass: "product__options-item" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "product__options-item-caption",
                                },
                                [_vm._v(_vm._s(name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "product__options-item-value" },
                                [
                                  typeof value == "object"
                                    ? [
                                        _c(
                                          "a",
                                          { attrs: { href: value.url } },
                                          [_vm._v(_vm._s(value.text))]
                                        ),
                                      ]
                                    : [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(value) +
                                            "\n                "
                                        ),
                                      ],
                                ],
                                2
                              ),
                            ]
                          )
                        }
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isProps
                ? _c(
                    "a",
                    {
                      staticClass:
                        "action-link action-link_default js-view-all-haracteristik",
                      attrs: { href: "javascript:void(0);" },
                    },
                    [
                      _c("span", { staticClass: "action-link__text" }, [
                        _vm._v("Все характеристики"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "catalog__description" },
            [
              _vm.item.description &&
              (_vm.item.description.preview || _vm.item.description.detail)
                ? [
                    _c("h3", { staticClass: "catalog__description-title" }, [
                      _vm._v("Описание"),
                    ]),
                    _vm._v(" "),
                    _vm.item.description.preview
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(_vm.item.description.preview),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.item.description.detail
                      ? _c("p", {
                          domProps: {
                            innerHTML: _vm._s(_vm.item.description.detail),
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.item.certificates && _vm.item.certificates.length > 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "product__action-link product__action-link_sertificat popup-image-gallery",
                      staticStyle: { float: "left", "margin-right": "20px" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "product__action-link-text",
                          attrs: {
                            href: "/upload/cert/" + _vm.item.certificates[0],
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.showModalSertificate()
                            },
                          },
                        },
                        [
                          _c("span", {
                            staticClass:
                              "product__action-link-icon icon icon-sertificat",
                          }),
                          _vm._v("\n          Сертификат\n        "),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.item.youtube_id
                ? _c(
                    "div",
                    {
                      staticClass:
                        "product__action-link product__action-link_sertificat popup-image-gallery",
                      staticStyle: { position: "unset" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video",
                          attrs: {
                            target: "_blank",
                            href:
                              "https://www.youtube.com/watch?v=" +
                              _vm.item.youtube_id,
                            title: "Видео",
                          },
                        },
                        [
                          _vm._v("\n          Видео "),
                          _c("img", {
                            staticStyle: { height: "25px" },
                            attrs: { src: "/img/youtube.png" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.item.manual
                ? _c(
                    "div",
                    {
                      staticClass:
                        "product__action-link product__action-link_sertificat popup-image-gallery",
                      staticStyle: { position: "unset" },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "popup-video product__picture-slider-thumbs-other-actions-item product__picture-slider-thumbs-other-actions-item_video",
                          attrs: {
                            target: "_blank",
                            href:
                              "/upload/manuals/" + _vm.item.vendorCode + ".pdf",
                            title: "Инструкция",
                          },
                        },
                        [
                          _vm._v("\n          Инструкция по сборке "),
                          _c("img", {
                            staticStyle: { height: "25px" },
                            attrs: { src: "/img/pdf.png" },
                          }),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("vue-swiper-products", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.item && Object.keys(_vm.item).length > 0,
            expression: "item && Object.keys(item).length > 0",
          },
        ],
        key: _vm.item.id,
        attrs: {
          user: _vm.user,
          items: _vm.item.analogues,
          "item-id": _vm.item.id,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "thumb-image img-content" }, [
      _c("img", { attrs: { src: "/img/empty-600.png" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }